export const ACTION_DEVICES_LOADED = "ACTION_DEVICES_LOADED";
export const ACTION_USERS_LOADED = "ACTION_USERS_LOADED";
export const ACTION_MAIL_RECIPIENTS_LOADED = "ACTION_MAIL_RECIPIENTS_LOADED";

export function AlertNotificationPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_DEVICES_LOADED: {
            return { ...state, ...action.payload };
        }
        case ACTION_USERS_LOADED: {
            return { ...state, ...action.payload };
        }
        case ACTION_MAIL_RECIPIENTS_LOADED: {
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}
